import { ProgressBar } from '@flos/react-ui';
import useAppState from '../state/appState';
import { PageConf, ProgressBarGroup } from '@topdanmark-onlinesolutions/claim-form-types';

const Progressbar = ({ pageId }: { pageId: string }) => {
    const formConfig = useAppState((state) => state.formConfig);

    if (!formConfig) {
        return null;
    }

    if (!pageId) {
        return null;
    }

    switch (formConfig.progressBarType) {
        case 'pageBased':
            return <PageBasedProgressBar pages={formConfig.pages} currentPageId={pageId} />;

        case 'grouped':
            return (
                <GroupedProgressBar
                    progressBarGroups={formConfig.progressBarGroups}
                    pages={formConfig.pages}
                    currentPageId={pageId}
                />
            );

        default:
            return null;
    }
};

/**
 * Paged based progress bar - one step per page if showProgressBar == true
 * @param formConfig
 * @param pageId
 * @returns
 */
const PageBasedProgressBar = ({ pages, currentPageId }: { pages: PageConf[]; currentPageId: string }) => {
    let totalSteps = 0;
    let currentStep: undefined | number = undefined;

    pages.forEach((page) => {
        if (!page.showProgressBar) {
            return;
        }

        totalSteps++;

        if (page.pageId === currentPageId) {
            currentStep = totalSteps;
        }
    });

    if (currentStep === undefined) {
        return null;
    }

    return (
        <div className="progress-bar">
            <ProgressBar currentStep={currentStep} totalSteps={totalSteps} />
        </div>
    );
};

/**
 * Bundled progress bar - grouped by progressBarGroups property
 * @param formConfig
 * @param pageId
 * @returns
 */
const GroupedProgressBar = ({
    progressBarGroups,
    pages,
    currentPageId: pageId
}: {
    progressBarGroups: ProgressBarGroup[];
    pages: PageConf[];
    currentPageId: string;
}) => {
    const totalSteps = progressBarGroups.length;

    const currentPage = pages.find((page: PageConf) => page.pageId === pageId);

    const currentStep = progressBarGroups.findIndex(
        (group) => group.progressBarGroupId === currentPage?.progressBarGroupId
    );

    const group = progressBarGroups.find((group) => group.progressBarGroupId === currentPage?.progressBarGroupId);

    return (
        <div className="progress-bar">
            <div className="u-text-center paragraph--small u-color-secondary-4-medium u-spacing-stack-m">
                <strong>{group?.caption}</strong>
            </div>
            <ProgressBar currentStep={currentStep + 1} totalSteps={totalSteps} />
        </div>
    );
};

export default Progressbar;
